export default __webpack_public_path__ + "static/SohneMono-Halbfett-b4a8156106d886201f30aae3701a6219.woff2";